import type { ReactNode } from "react";
import TrashIconButton from "../trashIconButton/TrashIconButton";
import useBreakpoints, { Breakpoint } from "../../hooks/useBreakpoints";

interface CollapsibleFormSectionProps {
    label: string;
    onRemove: () => void;
    iconAriaLabel: string;
    children: ReactNode;
}

const CollapsibleFormSection = (props: CollapsibleFormSectionProps) => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    return (
        <div className="flex flex-col gap-xs w-full">
            <div className="flex items-center justify-between">
                <p className="text-l text-p6-grey-dark">{props.label}</p>
                <div className={getStyleBasedOnBreakpoint(Breakpoint.MD, "hidden", "flex")}>
                    <TrashIconButton
                        onClick={props.onRemove}
                        ariaLabel={props.iconAriaLabel}
                    />
                </div>
            </div>
            <div className="flex gap-m items-center w-full">
                <div className="flex-1">{props.children}</div>
                <div className={getStyleBasedOnBreakpoint(Breakpoint.MD, "flex", "hidden")}>
                    <TrashIconButton
                        onClick={props.onRemove}
                        ariaLabel={props.iconAriaLabel}
                    />
                </div>
            </div>
        </div>
    );
};

export default CollapsibleFormSection;
